<template>
<div>
    <navbar/>
    <div class="container-fluid">
        <h3>Crear Caso</h3>
        <button @click="agregar">Add</button>
        <div class="row">
            <div class="col-md-6 ">
                Contacto: 
                <select class="form-control" v-model="form.idcontacto" @change="selectContacto(form.idcontacto)">
                    <option v-for="item in allContacto" :key="item.id" :value="item.id">{{item.nombre}}</option>
                </select>
            </div>
            <div class="col-md-6 ">
                Producto: 
                <select class="form-control" v-model="form.idproducto" @change="selectProducto(form.idproducto)">
                    <option v-for="item in allProductos" :key="item.id" :value="item.id">{{item.nombre}}</option>
                </select>
            </div> 
        </div>

        <div class="row">
            <div class="col-md-4 ">
                Motivo: 
                <select class="form-control" v-model="form.idtipo" @change="selectMotivo(form.idtipo)">
                    <option v-for="item in allMotivos" :key="item.id" :value="item.id">{{item.nombre}}</option>
                </select>
            </div>
            <div class="col-md-4 ">
                subMotivo: 
                <select class="form-control" v-model="form.idsubtipo">
                    <option v-for="item in allSubMotivos" :key="item.id" :value="item.id">{{item.nombres}}</option>
                </select>
            </div> 
            <div class="col-md-4 ">
                Prioridad: 
                <select class="form-control" v-model="form.idprioridad">
                    <option v-for="item in allPrioridades" :key="item.id" :value="item.id">{{item.nivel}}</option>
                </select>
            </div> 
        </div>

        <div class="row">
            <div class="col-md-4 ">
                Estado: 
                <select class="form-control" v-model="form.idestado">
                    <option v-for="item in allEstados" :key="item.id" :value="item.id">{{item.descripcion}}</option>
                </select>
            </div>
            <div class="col-md-4 ">
                Cuenta: 
                <select class="form-control" v-model="form.idcuenta">
                    <option v-for="item in allCuentas" :key="item.id" :value="item.id">{{item.identificador}} - {{item.razonsocial}}</option>
                </select>
            </div> 
            <div class="col-md-4 ">
                Proceso: 
                <select class="form-control" v-model="form.idworkflow">
                    <option v-for="item in allProcesos" :key="item.id" :value="item.id">{{item.nombre}}</option>
                </select>
            </div> 
        </div>

            <div class="row">
            <div  class="col-md-12 ">
                Asunto: 
                <textarea class="form-control" v-model="form.asunto"></textarea>
            </div>
        </div>     
            <pre>{{form}}</pre>
    </div> 
</div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
export default {
    components: {
        navbar: () => import('@/views/Agente/navBar.vue')
    },
    data(){
        return{
            form:{
                idusuarioasignado: 77,
                origen:"AgenteWeb",
                idsla:null,
                cf: {
                        
                    }
            }
        }
    },
    computed:{
        //subtipó
        ...mapGetters('validatetoken', { oneCaso: 'oneCaso',
            allContacto: 'allContacto',
            allProductos: 'allProductos',
            allMotivos: 'allMotivos',
            allSubMotivos: 'allSubMotivos',
            allPrioridades: 'allPrioridades',
            allEstados: 'allEstados',
            allCuentas: 'allCuentas',
            allProcesos: 'allProcesos'
        }),
        idCaso(){
            return {
                id: this.$route.params.id
            } 
        },
        idCuentaForCase(){
            return {
                idcuenta: 0
            }
        }
    },
    methods:{
        ...mapActions('validatetoken', { getBy: 'getBy',
            save: 'save', add: 'add',
            getContacto: 'getContacto',
            getAllProductos: 'getAllProductos',
            getAllMotivos: 'getAllMotivos',
            getAllSubMotivos: 'getAllSubMotivos',
            getPrioridades: 'getPrioridades',
            getAllEstados: 'getAllEstados',
            getAllCuentas: 'getAllCuentas',
            getAllProcesos: 'getAllProcesos'
            //proceso
        }),
        getAll(){
            Promise.all([
                this.getContacto(this.idCuentaForCase)
                 .then((data)=>{
                    this.$store.commit('validatetoken/setAllContacto', data.data)
                }),
                this.getPrioridades(),
                this.getAllEstados(),
                this.getAllProcesos({
                    activo: 1,
                    cantidad: 10,
                    pagina: 1
                })
            ])
        },
        actualizar(){
            this.save()
        },
        agregar(){
            this.add(this.form)
        },
        selectContacto(id){
            let query = {
                idcontacto: id
            }

            Promise.all([
                this.getAllCuentas({...query,
                    cantidad: 10,
                    pagina: 1
                }),
                this.getAllProductos(query)
            ])

        },
        selectProducto(id){
            let query = {
                idproducto: id,
                idcontacto: this.oneCaso.idcontacto
            }
           
             this.getAllMotivos(query)
        },
        selectMotivo(id){
            let query = {
                idtipo: id,
                idproducto: this.oneCaso.idtipo,
                idcontacto: this.oneCaso.idcontacto
            }
            this.getAllSubMotivos(query)
        },
    },
    created() {
        this.getAll()
    },
}
</script>

<style>

</style>